if (editable)
{
	require('blueimp-file-upload');
	console.log('LEAD Edit started');
	var leadService = null;
	var editableElements = $('[data-editable="true"]:not([data-img="true"])');
	var linkElements = $('[data-link="true"]');
	var editableImages = $('[data-img="true"]');
	var idLeadPage = $('[data-idlead]').data('idlead');

	Util.service("WSPortobelloLead", true, {
		exceptionHandler: alertInterface.showError,
		reflectSuccess: function(service) {
			leadService = service;
		}
	});
	

	editableImages.each( function (elem) {
		var component = $(this);
		var idParent = component.parents('[data-id]').data('id');
		//alert(idParent);
		//var type = component.nodeName;
		var root = component.data('root');
		var idx = '';
		if (typeof root != 'undefined')
		{
			idx = component.data('idx');
		}
		else
		{
			 var root = '';
		}
		var dataHtml = component.data('src');

		var idElement = idParent + '-' + dataHtml + '_' + root + idx;
		$('body').append('<input style="visibility: hidden;" id="'+idElement+'" type="file" name="files[]" data-idparent="'+idParent+'" data-html="'+dataHtml+'" data-root="'+root+'" data-idx="'+idx+'"  data-url="/manager/upload/index.php" multiple>')
		

		$('#'+idElement).fileupload({
			dataType: 'json',
			dropZone: component,
			done: function (e, data) {
				console.log(e.target);
				console.log(data);
				//$.each(data.result.files, function (index, file) {
				//	$('<p></p>').text(file.name).appendTo(document.body);
				//});
				component.attr('src', data.result.url);
				UtilUi.alert('Imagem enviada!','success');
			},
			drop: function (e, data) {
				UtilUi.alert('Enviando imagem...','warning');
				console.log(e.target);
				console.log(data);
				//$.each(data.files, function (index, file) {
				//	alert('Dropped file: ' + file.name);
				//});
				//component.attr('src', data.result.url);
			},
    	});

		$('#'+idElement).bind('fileuploadsubmit', function (e, data) {
			// The example input, doesn't have to be part of the upload form:
			data.formData = {
				'object': 'leadPageTemplateMedia',
				'idLeadPage': idLeadPage,
				'idParent': idParent,
				'idx': idx,
				'root': root,
				'dataHtml': dataHtml
			}
		});
		

		component.on('click', function(e)
		{
			$('#'+idElement).trigger('click');
		})
	});
	
	// gravar dados
	function saveElements()
	{
		var editedElements = $('[contentEditable="true"]');
		editedElements.each(function(ele) {
			var component = $(this);
			var idParent = component.parents('[data-id]').data('id');
			//alert(idParent);
			var type = component.nodeName;
			var root = component.data('root');
			if (typeof root != 'undefined' && root)
			{
				var idx = component.data('idx');
			}
			else
			{
				var root = null;
			}
			switch(type)
			{
				case 'A':
					var dataHtml = component.data('href');
					//alert(dataHref);
					break;
				case 'IMG':
					var dataHtml = component.data('src');
					//alert(dataSrc);
					break;
				default:
					var dataHtml = component.data('html');
			}
			
			//alert(dataHtml);

			var html = btoa(component.html());
			//alert(html);
			if (idParent && dataHtml)
			{
				leadService.updateLeadPageContent(idLeadPage, idParent, dataHtml, html, root, idx, { 
						success: function(result)
						{
							console.log(result);

							UtilUi.alert('Salvando...','success');
							component.attr('contentEditable', false)
						}
					}
				);
			}
			
		});
	}

	// click outside element save content
	$('body').on('click', function()
	{
		saveElements();
	});

	// cancel edit
	$(document).keyup(function(e) {
			if (e.key === "Escape") { // escape key maps to keycode `27`
				var editedElements = $('[contentEditable="true"]');
				editedElements.attr('contentEditable', false);

				UtilUi.alert('Edição abortada!','warning');
			}
		}
	);

	linkElements.on('click',function(e)
		{
			e.preventDefault();
			console.log('Abort click simples no link');
			return false;
		}
	);

	editableElements.on('dblclick',function(e)
		{
			e.preventDefault();
			saveElements();
			$(this).attr('contentEditable', true).focus();
			return false;
		}
	);

	
};